<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <!-- CADASTRO-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Editar leilão</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- ATIVAR REGRESSIVA -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_acionar_regressiva_apos">Ativar regressiva faltando (s)</label>
                <input
                  class="form-control"
                  id="leilao_acionar_regressiva_apos"
                  placeholder="Tempo em segundos"
                  v-model="formData.leilao_acionar_regressiva_apos"
                />

                <span style="color: red" v-for="error in v$.leilao_acionar_regressiva_apos.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- REINICIAR TEMPO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_regressiva">Reiniciar o tempo em (s)</label>
                <input class="form-control" id="leilao_regressiva" placeholder="Tempo em segundos" v-model="formData.leilao_regressiva" />

                <span style="color: red" v-for="error in v$.leilao_regressiva.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- INTERVALO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_lote_intervalo">Intervalo entre os lotes (s)</label>
                <input class="form-control" id="leilao_lote_intervalo" placeholder="Tempo em segundos" v-model="formData.leilao_lote_intervalo" />

                <span style="color: red" v-for="error in v$.leilao_lote_intervalo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- TEMPO PRIMEIRO LOTE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_primeiro_lote_margem_tempo">Primeiro lote inicia com (s)</label>
                <input
                  class="form-control"
                  id="leilao_primeiro_lote_margem_tempo"
                  placeholder="Tempo em segundos"
                  v-model="formData.leilao_primeiro_lote_margem_tempo"
                />

                <span style="color: red" v-for="error in v$.leilao_primeiro_lote_margem_tempo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILOEIRO RESPONSÁVEL -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_cidade">Leiloeiro responsável</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.leiloeiro_id">
                  <option v-for="leiloeiro in leiloeiros" :key="leiloeiro.id" :value="leiloeiro.id">
                    {{ leiloeiro.matricula + " - " + leiloeiro.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.leiloeiro_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- TAXA -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_taxa_administrativa">Taxa administrativa</label>
                <input
                  class="form-control"
                  id="leilao_taxa_administrativa"
                  placeholder="0.00"
                  v-model="formData.leilao_taxa_administrativa"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">UF</label>

                <select
                  class="custom-select rounded-0"
                  id="endereco_estado"
                  v-model="formData.estado_id"
                  @change="buscarCidades()"
                  style="text-transform: uppercase"
                >
                  <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                    {{ estado.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.estado_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select
                  @change="changeCidade"
                  class="custom-select rounded-0"
                  id="endereco_cidade"
                  v-model="formData.cidade_id"
                  style="text-transform: uppercase"
                >
                  <option v-for="cidade in my_cidades" :key="cidade.id" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.cidade_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- COMITENTES -->
            <div class="col-sm-6">
              <div class="form-group" id="form_group_comitente">
                <label for="comitente">Comitente</label>
                <div class="input-group">
                  <v-autocomplete
                    variant="outlined"
                    :items="my_comitentes"
                    item-title="nome"
                    item-value="id"
                    v-model="formData.comitente_id"
                    density="compact"
                  ></v-autocomplete>

                  <div class="input-group-append">
                    <button
                      style="max-height: 40px"
                      type="submit"
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#comitente-modal"
                      @click="cadastrarComitente"
                    >
                      <i class="fas fa-plus"></i>
                      Adicionar
                    </button>
                  </div>
                </div>

                <span style="color: red" v-for="error in v$.comitente_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!--
            <div v-if="cadastrar_comitente">
              <admin-cadastrar-comitente :estados="estados" :modal="true" :action="buscarComitenteCadastrado" />
            </div>
            -->

            <div>
              <admin-cadastrar-comitente
                v-if="cadastrar_comitente"
                :estados="estados"
                :estado_selecionado="formData.estado_id"
                :cidade_selecionada="formData.cidade_id"
                :cidades_buscadas="my_cidades"
                :modal="true"
                :action="buscarComitenteCadastrado"
              />
            </div>

            <!-- MODO GENÉRICO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_modo_generico">Modo genérico</label>

                <select
                  class="custom-select rounded-0"
                  id="leilao_modo_generico"
                  v-model="formData.leilao_modo_generico"
                  style="text-transform: uppercase"
                >
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_modo_generico.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- TIPO LEILAO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_tipo">
                  Tipo (modalidade)
                  <button
                    @click="showModalidadeInfo()"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="border-radius: 60%; margin-left: 5px; font-size: 12px; font-weight: bold; padding-top: 1px; padding-bottom: 1px"
                  >
                    ?
                  </button>
                </label>

                <select
                  class="custom-select rounded-0"
                  id="leilao_tipo"
                  v-model="formData.leilao_tipo"
                  @change="alterarTipoLeilao()"
                  style="text-transform: uppercase"
                >
                  <option value="extra">Extra</option>
                  <option value="judicial">Judicial</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_tipo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- PROCESSO -->
            <div class="col-sm-6">
              <div class="form-group" id="form_group_processo">
                <label for="endereco_cidade">Processo
                  <span style="margin-left: 15px; color: red" v-if="leilao.processo_id && lotes_processo_divergente && lotes_processo_divergente > 0">* Processo divergente de um ou mais lotes</span>                 
                </label>

                <div class="input-group">
                  <v-autocomplete
                    :disabled="formData.leilao_tipo == 'extra'"
                    variant="outlined"
                    :items="my_processos"
                    item-title="processo_numero"
                    item-value="id"
                    v-model="formData.processo_id"
                    density="compact"
                  ></v-autocomplete>

                  <div class="input-group-append">
                    <button
                      :disabled="formData.leilao_tipo == 'extra'"
                      type="submit"
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#processo-modal"
                      @click="cadastrarProcesso"
                      style="max-height: 40px"
                    >
                      <i class="fas fa-plus"></i>
                      Adicionar
                    </button>
                  </div>
                </div>

                <span v-if="formData.leilao_tipo == 'judicial'" style="color: red" v-for="error in v$.processo_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <div>
              <admin-cadastrar-processo
                v-if="cadastrar_processo"
                :leiloeiros="leiloeiros"
                :estado_selecionado="formData.estado_id"
                :cidade_selecionada="formData.cidade_id"
                :cidades_buscadas="my_cidades"
                :estados="estados"
                :modal="true"
                :action="buscarProcessoCadastrado"
              />
            </div>

            <!-- TITULO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_titulo">Título</label>
                <input
                  class="form-control"
                  id="leilao_titulo"
                  placeholder="Título"
                  v-model="formData.leilao_titulo"
                  @blur="upper('leilao_titulo')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.leilao_titulo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DESCRIÇÃO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_descricao">Descrição</label>
                <input
                  class="form-control"
                  id="leilao_descricao"
                  placeholder="Título"
                  v-model="formData.leilao_descricao"
                  @blur="upper('leilao_descricao')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.leilao_descricao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LOCAL DO LEILÃO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_local">Local do leilão</label>
                <input class="form-control" id="leilao_local" placeholder="Título" v-model="formData.leilao_local" />

                <span style="color: red" v-for="error in v$.leilao_local.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LOGO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="logo">Logo</label>

                <select class="custom-select rounded-0" id="logo" v-model="formData.logo_id" style="text-transform: uppercase">
                  <option v-for="logo in logos" :key="logo.id" :value="logo.id">
                    {{ logo.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.logo_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NÚMERO DE PRAÇAS -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="leilao_num_pracas">Número de praças</label>

                <select class="custom-select rounded-0" id="leilao_num_pracas" v-model="formData.leilao_num_pracas" @change="changePracas()">
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                  <option :value="4">4</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_num_pracas.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILÃO 01 -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_1_data">1º Leilão</label>
                <div class="input-group">
                  <InputMask
                    id="basic"
                    class="form-control"
                    v-model="formData.leilao_1_data"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <span style="color: red" v-for="error in v$.leilao_1_data.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- MODALIDADE LEILÃO 01 -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_1_modalidade">Modalidade</label>

                <select class="custom-select rounded-0" id="leilao_tipo" v-model="formData.leilao_1_modalidade" style="text-transform: uppercase">
                  <option value="automatico">Automático</option>
                  <option value="controlado">Controlado</option>
                  <option value="presencial">Presencial</option>
                  <option value="simultaneo">Simultâneo</option>
                  <option value="venda">Venda</option>
                  <option value="virtual">Virtual</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_1_modalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILÃO 02 -->
            <div class="col-sm-6" v-show="formData.leilao_num_pracas >= 2">
              <div class="form-group">
                <label>2º Leilão</label>
                <div class="input-group date" id="reservationdatetime2" data-target-input="nearest">
                  <InputMask
                    id="basic"
                    class="form-control"
                    v-model="formData.leilao_2_data"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <span v-if="formData.leilao_num_pracas >= 2" style="color: red" v-for="error in v$.leilao_2_data.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- MODALIDADE LEILÃO 02 -->
            <div class="col-sm-6" v-if="formData.leilao_num_pracas >= 2">
              <div class="form-group">
                <label for="leilao_2_modalidade">Modalidade</label>

                <select class="custom-select rounded-0" id="leilao_tipo" v-model="formData.leilao_2_modalidade" style="text-transform: uppercase">
                  <option value="automatico">Automático</option>
                  <option value="controlado">Controlado</option>
                  <option value="presencial">Presencial</option>
                  <option value="simultaneo">Simultâneo</option>
                  <option value="venda">Venda</option>
                  <option value="virtual">Virtual</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_2_modalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILÃO 03 -->
            <div class="col-sm-6" v-show="formData.leilao_num_pracas >= 3">
              <div class="form-group">
                <label>3º Leilão</label>
                <div class="input-group date" id="reservationdatetime3" data-target-input="nearest">
                  <InputMask
                    id="basic"
                    class="form-control"
                    v-model="formData.leilao_3_data"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <span v-if="formData.leilao_num_pracas >= 3" style="color: red" v-for="error in v$.leilao_3_data.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- MODALIDADE LEILÃO 03 -->
            <div class="col-sm-6" v-if="formData.leilao_num_pracas >= 3">
              <div class="form-group">
                <label for="leilao_3_modalidade">Modalidade</label>

                <select class="custom-select rounded-0" id="leilao_tipo" v-model="formData.leilao_3_modalidade" style="text-transform: uppercase">
                  <option value="automatico">Automático</option>
                  <option value="controlado">Controlado</option>
                  <option value="presencial">Presencial</option>
                  <option value="simultaneo">Simultâneo</option>
                  <option value="venda">Venda</option>
                  <option value="virtual">Virtual</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_3_modalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LEILÃO 04 -->
            <div class="col-sm-6" v-show="formData.leilao_num_pracas >= 4">
              <div class="form-group">
                <label for="leilao_4_data">4º Leilão</label>
                <div class="input-group date" id="reservationdatetime4" data-target-input="nearest">
                  <InputMask
                    id="basic"
                    class="form-control"
                    v-model="formData.leilao_4_data"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <span v-if="formData.leilao_num_pracas >= 4" style="color: red" v-for="error in v$.leilao_4_data.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- MODALIDADE LEILÃO 04 -->
            <div class="col-sm-6" v-if="formData.leilao_num_pracas >= 4">
              <div class="form-group">
                <label for="leilao_4_modalidade">Modalidade</label>

                <select class="custom-select rounded-0" id="leilao_tipo" v-model="formData.leilao_4_modalidade" style="text-transform: uppercase">
                  <option value="automatico">Automático</option>
                  <option value="controlado">Controlado</option>
                  <option value="presencial">Presencial</option>
                  <option value="simultaneo">Simultâneo</option>
                  <option value="venda">Venda</option>
                  <option value="virtual">Virtual</option>
                </select>

                <span style="color: red" v-for="error in v$.leilao_4_modalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- INFORMAÇÕES GERAIS -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="leilao_info_geral">Informações gerais</label>

                <Editor v-model="formData.leilao_info_geral" editorStyle="height: 200px" />
              </div>
            </div>

            <!-- DATA LIBERAR LANCE -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="leilao_data_disponibilizar">Liberar os lances a partir de</label>
                <div class="input-group date" id="data_disponibilizar" data-target-input="nearest">
                  <InputMask
                    id="basic"
                    class="form-control"
                    v-model="formData.leilao_data_disponibilizar"
                    placeholder="__/__/____  00:00"
                    mask="99/99/9999 99:99:99"
                    slotChar="__/__/____ 00:00"
                  />
                </div>

                <span style="color: red" v-for="error in v$.leilao_data_disponibilizar.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- BLOQUEAR HABILITAÇÕES -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="leilao_tempo_limite_habilitacao">Bloquear habilitações faltando (min)</label>
                <input type="number" class="form-control" id="leilao_tempo_limite_habilitacao" v-model="formData.leilao_tempo_limite_habilitacao" />

                <span style="color: red" v-for="error in v$.leilao_tempo_limite_habilitacao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- EXIBIR HABILITADOS 
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label for="leilao_exibir_habilitados">Exibir número de habilitados do leilão</label>

                                <select class="custom-select rounded-0" id="leilao_exibir_habilitados"
                                    v-model="formData.leilao_exibir_habilitados">
                                    <option :value="0">Não</option>
                                    <option :value="1">Sim</option>
                                </select>

                                <span style="color: red" v-for="error in v$.leilao_exibir_habilitados.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </span>
                            </div>
                        </div>
                        -->

            <!-- LEILÃO DE TESTE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="is_teste">Leilão de teste</label>

                <select class="custom-select rounded-0" id="is_teste" v-model="formData.is_teste" style="text-transform: uppercase">
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.is_teste.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="validateFields()">Salvar</button>
          <a type="submit" onclick="history.back()" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";
import moment from "moment";
import Editor from "primevue/editor";

import InputMask from "primevue/inputmask";
import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["estados", "leiloeiros", "logos", "leilao", "cidades", "processos", "comitentes", "lotes_processo_divergente"],

  components: { Loading, Editor, InputMask },

  data() {
    return {
      nome: "",
      isLoading: false,
      cadastrar_comitente: false,
      cadastrar_processo: false,
      my_cidades: [],
      my_comitentes: [],
      my_processos: [],
    };
  },

  setup() {
    const formData = reactive({
      leilao_acionar_regressiva_apos: "180",
      leilao_regressiva: "180",
      leilao_lote_intervalo: "60",
      leilao_primeiro_lote_margem_tempo: "180",
      leiloeiro_id: "",
      leilao_taxa_administrativa: "",
      cidade_id: "",
      estado_id: "",
      comitente_id: "",
      leilao_modo_generico: 0,
      leilao_titulo: "",
      leilao_descricao: "",
      leilao_local: "www.rochaleiloes.com.br",
      logo_id: "",
      leilao_tipo: "",
      leilao_num_pracas: "",
      leilao_1_modalidade: "virtual",
      leilao_2_modalidade: "virtual",
      leilao_3_modalidade: "virtual",
      leilao_4_modalidade: "virtual",
      leilao_1_data: "",
      leilao_2_data: "",
      leilao_3_data: "",
      leilao_4_data: "",
      leilao_data_disponibilizar: "",
      leilao_tempo_limite_habilitacao: "",
      leilao_exibir_habilitados: 0,
      is_teste: 0,
      leilao_info_geral: "",
      processo_id: "",
    });

    const rules = computed(() => {
      let local_rules = {
        leilao_acionar_regressiva_apos: { required },
        leilao_regressiva: { required },
        leilao_lote_intervalo: { required },
        leilao_primeiro_lote_margem_tempo: { required },
        leiloeiro_id: { required },
        cidade_id: { required },
        estado_id: { required },
        comitente_id: { required },
        leilao_modo_generico: { required },
        leilao_titulo: { required },
        leilao_descricao: { required },
        leilao_local: { required },
        logo_id: { required },
        leilao_tipo: { required },
        leilao_num_pracas: { required },
        leilao_1_data: {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
        },
        leilao_1_modalidade: { required },
        leilao_data_disponibilizar: {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
        },
        leilao_tempo_limite_habilitacao: { required },
        leilao_exibir_habilitados: { required },
        is_teste: { required },
      };

      if (formData.leilao_tipo == "judicial") {
        local_rules.processo_id = {
          required,
        };
      }

      if (formData.leilao_num_pracas >= 2) {
        local_rules.leilao_2_data = {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
          minDatePraca2: helpers.withMessage(" Esta praça deve ser após a 1º praça.", minDatePraca2),
        };
        local_rules.leilao_2_modalidade = {
          required,
        };
      }

      if (formData.leilao_num_pracas >= 3) {
        local_rules.leilao_3_data = {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
          minDatePraca3: helpers.withMessage(" Esta praça deve ser após a 2º praça.", minDatePraca3),
        };
        local_rules.leilao_3_modalidade = {
          required,
        };
      }

      if (formData.leilao_num_pracas >= 4) {
        local_rules.leilao_4_data = {
          required,
          minValue: helpers.withMessage(" Digite uma data válida.", minDate),
          minValue: helpers.withMessage(" Digite uma data válida.", validDate),
          minDatePraca4: helpers.withMessage(" Esta praça deve ser após a 3º praça.", minDatePraca4),
        };
        local_rules.leilao_4_modalidade = {
          required,
        };
      }

      return local_rules;
    });

    const validDate = (value) => {
      return moment(value, "DD/MM/yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss") != "Invalid date";
    };

    const minDatePraca4 = (date) => {
      if (!formData.leilao_2_data || !date) {
        return true;
      } else {
        let data = new Date(moment(date, "DD-MM-yyyy HH:mm"));
        let data2 = new Date(moment(formData.leilao_3_data, "DD-MM-yyyy HH:mm"));
        return data > data2;
      }
    };

    const minDatePraca3 = (date) => {
      if (!formData.leilao_2_data || !date) {
        return true;
      } else {
        let data = new Date(moment(date, "DD-MM-yyyy HH:mm"));
        let data2 = new Date(moment(formData.leilao_2_data, "DD-MM-yyyy HH:mm"));
        return data > data2;
      }
    };

    const minDatePraca2 = (date) => {
      if (!formData.leilao_2_data || !date) {
        return true;
      } else {
        let data = new Date(moment(date, "DD-MM-yyyy HH:mm"));
        let data2 = new Date(moment(formData.leilao_1_data, "DD-MM-yyyy HH:mm"));
        return data > data2;
      }
    };

    const minDate = (date) => {
      return new Date(date) >= new Date();
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    let url = "http://127.0.0.1:8000/admin/leilao/16/lotes/cadastrar_lote";

    let leilao_id = url.split("/leilao")[1].split("/")[1];

    console.log("Lotes divergentes ");
    console.log(this.lotes_processo_divergente);
    console.log("Meu leilão id = ");
    console.log(leilao_id);

    this.my_cidades = this.cidades;
    this.my_comitentes = this.comitentes;
    this.my_processos = this.processos;

    console.log(this.leilao);

    this.formData.processo_id = this.leilao.processo_id;
    this.formData.leilao_acionar_regressiva_apos = this.leilao.leilao_acionar_regressiva_apos;
    this.formData.leilao_regressiva = this.leilao.leilao_regressiva;
    this.formData.leilao_lote_intervalo = this.leilao.leilao_lote_intervalo;
    this.formData.leilao_primeiro_lote_margem_tempo = this.leilao.leilao_primeiro_lote_margem_tempo;
    this.formData.leiloeiro_id = this.leilao.leiloeiro_id;
    this.formData.leilao_taxa_administrativa = this.leilao.leilao_taxa_administrativa;
    this.formData.cidade_id = this.leilao.cidade_id;
    this.formData.estado_id = this.leilao.estado_id;
    this.formData.comitente_id = this.leilao.comitente_id;
    this.formData.leilao_modo_generico = this.leilao.leilao_modo_generico;
    this.formData.leilao_titulo = this.leilao.leilao_titulo;
    this.formData.leilao_descricao = this.leilao.leilao_descricao;
    this.formData.leilao_local = this.leilao.leilao_local;
    this.formData.logo_id = this.leilao.logo_id;
    this.formData.leilao_tipo = this.leilao.leilao_tipo;
    this.formData.leilao_num_pracas = this.leilao.leilao_num_pracas;
    this.formData.leilao_1_modalidade = this.leilao.leilao_1_modalidade;
    this.formData.leilao_2_modalidade = this.leilao.leilao_2_modalidade;
    this.formData.leilao_3_modalidade = this.leilao.leilao_3_modalidade;
    this.formData.leilao_4_modalidade = this.leilao.leilao_4_modalidade;
    this.formData.leilao_tempo_limite_habilitacao = this.leilao.leilao_tempo_limite_habilitacao;
    this.formData.leilao_exibir_habilitados = this.leilao.leilao_exibir_habilitados;
    this.formData.is_teste = this.leilao.is_teste;
    this.formData.leilao_info_geral = this.leilao.leilao_info_geral;

    this.formData.leilao_data_disponibilizar = this.formatSelectedDate2(this.leilao.leilao_data_disponibilizar);
    this.formData.leilao_1_data = this.formatSelectedDate2(this.leilao.leilao_1_data);

    if (this.leilao.leilao_2_data) {
      this.formData.leilao_2_data = this.formatSelectedDate2(this.leilao.leilao_2_data);
    }

    if (this.leilao.leilao_3_data) {
      this.formData.leilao_3_data = this.formatSelectedDate2(this.leilao.leilao_3_data);
    }

    if (this.leilao.leilao_4_data) {
      this.formData.leilao_4_data = this.formatSelectedDate2(this.leilao.leilao_4_data);
    }

    /*
    this.$nextTick(function () {
      if (this.leilao.leilao_2_data) {
        this.formData.leilao_2_data = this.formatSelectedDate2(this.leilao.leilao_2_data);
      }

      if (this.leilao.leilao_3_data) {
        this.formData.leilao_3_data = this.formatSelectedDate2(this.leilao.leilao_3_data);
      }

      if (this.leilao.leilao_4_data) {
        this.formData.leilao_4_data = this.formatSelectedDate2(this.leilao.leilao_4_data);
      }
    });
    */
  },

  methods: {
    showModalidadeInfo() {
      this.$swal
        .fire({
          icon: "info",
          title: "Tipo (modalidade)",
          padding: "1.5em",
          text: 'Esse campo aparece na tela do usuário como "Modalidade".',
        })
        .then(function () {});
    },

    cadastrarProcesso() {
      if (this.formData.cidade_id) {
        this.cadastrar_processo = true;
      } else {
        this.cadastrar_processo = false;
        this.showErrorMessageWithButton("Ops...", "Selecione uma cidade.");
      }
    },

    cadastrarComitente() {
      if (this.formData.cidade_id) {
        this.cadastrar_comitente = true;
      } else {
        this.cadastrar_comitente = false;
        this.showErrorMessageWithButton("Ops...", "Selecione uma cidade.");
      }
    },

    buscarprocessos() {
      let data = {
        cidade_id: this.formData.cidade_id,
        estado_id: this.formData.estado_id,
        inicio: 0,
        tamanho: 10000,
      };

      console.log("Buscando processos");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          console.log("Processos");
          console.log(response.data.processos);
          this.my_processos = response.data.processos;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarComitentes() {
      let data = {
        cidade: this.formData.cidade_id,
        estado: this.formData.estado_id,
        inicio: 0,
        tamanho: 10000,
        alfabetico: true,
      };

      axios
        .post(`/admin/comitente/search`, data)
        .then((response) => {
          this.my_comitentes = response.data.comitentes;

          for (let i = 0; i < this.my_comitentes.length; i++) {
            if (this.my_comitentes[i].nome) {
              this.my_comitentes[i].nome = this.my_comitentes[i].nome.toUpperCase();
            }
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    upper(field_name) {
      console.log(field_name);
      this.formData[field_name] = this.formData[field_name].toUpperCase();
      console.log(this.formData[field_name]);
    },

    alterarTipoLeilao() {
      if (this.formData.leilao_tipo == "extra") {
        this.formData.processo = null;
      }
    },

    changePracas() {
      if (this.formData.leilao_num_pracas < 2) {
        document.getElementById("data_leilao_2").value = "";
        this.formData.leilao_2_modalidade = "";
      }

      if (this.formData.leilao_num_pracas < 3) {
        document.getElementById("data_leilao_3").value = "";
        this.formData.leilao_3_modalidade = "";
      }

      if (this.formData.leilao_num_pracas < 4) {
        document.getElementById("data_leilao_4").value = "";
        this.formData.leilao_4_modalidade = "";
      }
    },

    async validateFields() {
      this.cadastrar_comitente = false;
      this.cadastrar_processo = false;

      this.$nextTick(async function () {
        /*
        if (this.formData.leilao_tipo == "extra") {
          this.formData.processo_id = null;
        }
          */

        const result = await this.v$.$validate();

        if (result) {
          this.update();
        }
      });
    },

    formatSelectedDate(date) {
      date = new Date(date);
      return moment(date).format("yyyy-MM-DD HH:mm:ss");
    },

    //FORMATA A DATA PARA ENVIAR PARA O BANCO (De DD-MM-yyyy HH:mm:ss Para yyyy-MM-DD HH:mm:ss )
    formatSelectedDate3(date) {
      return moment(date, "DD-MM-yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss");
    },

    //FORMATA A DATA VINDA DO BANCO (De yyyy-MM-DD HH:mm:ss Para DD-MM-yyyy HH:mm:ss)
    formatSelectedDate2(date) {
      return moment(date).format("DD-MM-yyyy HH:mm:ss");
    },

    buscarProcessoCadastrado(comitente_id) {
      let data = {
        comitente_id: comitente_id,
      };

      this.cadastrar_processo = false;

      axios
        .post(`/admin/processo/search_all`, data)
        .then((response) => {
          this.my_processos = response.data.processos;

          this.formData.processo_id = response.data.ultimo_processo.id;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarComitenteCadastrado(comitente_id) {
      let data = {
        comitente_id: comitente_id,
      };

      this.cadastrar_comitente = false;

      axios
        .post(`/admin/comitente/search_all`, data)
        .then((response) => {
          this.my_comitentes = response.data.comitentes;

          this.formData.comitente_id = this.my_comitentes[this.my_comitentes.length - 1].id;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    update() {
      this.isLoading = true;

      /*

      let data_leilao_1 = document.getElementById("data_leilao_1").value;
      this.formData.leilao_1_data = this.formatSelectedDate3(data_leilao_1);

      let data_disponibilizar = document.getElementById("leilao_data_disponibilizar").value;
      this.formData.leilao_data_disponibilizar = this.formatSelectedDate3(data_disponibilizar);

      if (this.formData.leilao_num_pracas >= 2) {
        let data_leilao_2 = document.getElementById("data_leilao_2").value;
        this.formData.leilao_2_data = this.formatSelectedDate3(data_leilao_2);
      }

      if (this.formData.leilao_num_pracas >= 3) {
        let data_leilao_3 = document.getElementById("data_leilao_3").value;
        this.formData.leilao_3_data = this.formatSelectedDate3(data_leilao_3);
      }

      if (this.formData.leilao_num_pracas >= 4) {
        let data_leilao_4 = document.getElementById("data_leilao_4").value;
        this.formData.leilao_4_data = this.formatSelectedDate3(data_leilao_4);
      }
      */

      let data = {
        leilao_1_data: this.formatSelectedDate3(this.formData.leilao_1_data),
        leilao_1_modalidade: this.formData.leilao_1_modalidade,
        leilao_id: this.leilao.id,
        processo_id: this.formData.processo_id,
        leilao_acionar_regressiva_apos: this.formData.leilao_acionar_regressiva_apos,
        leilao_regressiva: this.formData.leilao_regressiva,
        leilao_lote_intervalo: this.formData.leilao_lote_intervalo,
        leilao_primeiro_lote_margem_tempo: this.formData.leilao_primeiro_lote_margem_tempo,
        leiloeiro_id: this.formData.leiloeiro_id,
        leilao_taxa_administrativa: this.formData.leilao_taxa_administrativa,
        cidade_id: this.formData.cidade_id,
        estado_id: this.formData.estado_id,
        comitente_id: this.formData.comitente_id,
        leilao_modo_generico: this.formData.leilao_modo_generico,
        leilao_titulo: this.formData.leilao_titulo,
        leilao_descricao: this.formData.leilao_descricao,
        leilao_local: this.formData.leilao_local,
        logo_id: this.formData.logo_id,
        leilao_tipo: this.formData.leilao_tipo,
        leilao_num_pracas: this.formData.leilao_num_pracas,
        leilao_data_disponibilizar: this.formatSelectedDate3(this.formData.leilao_data_disponibilizar),
        leilao_tempo_limite_habilitacao: this.formData.leilao_tempo_limite_habilitacao,
        leilao_exibir_habilitados: this.formData.leilao_exibir_habilitados,
        is_teste: this.formData.is_teste,
        leilao_info_geral: this.formData.leilao_info_geral,
      };

      console.log(this.formData.leilao_1_data);
      console.log(this.formData.leilao_2_data);
      console.log(this.formData.leilao_3_data);

      if (this.formData.leilao_num_pracas < 4) {
        this.formData.leilao_4_data = null;
        this.formData.leilao_4_modalidade = null;

        data.leilao_4_data = null;
        data.leilao_4_modalidade = null;
      } else {
        data.leilao_4_data = this.formatSelectedDate3(this.formData.leilao_4_data);
        data.leilao_4_modalidade = this.formData.leilao_4_modalidade;
      }

      if (this.formData.leilao_num_pracas < 3) {
        this.formData.leilao_3_data = null;
        this.formData.leilao_3_modalidade = null;

        data.leilao_3_data = null;
        data.leilao_3_modalidade = null;
      } else {
        data.leilao_3_data = this.formatSelectedDate3(this.formData.leilao_3_data);
        data.leilao_3_modalidade = this.formData.leilao_3_modalidade;
      }

      if (this.formData.leilao_num_pracas < 2) {
        this.formData.leilao_2_data = null;
        this.formData.leilao_2_modalidade = null;

        data.leilao_2_data = null;
        data.leilao_2_modalidade = null;
      } else {
        data.leilao_2_data = this.formatSelectedDate3(this.formData.leilao_2_data);
        data.leilao_2_modalidade = this.formData.leilao_2_modalidade;
      }

      console.log("Atualizando");
      console.log(data);

      axios
        .post(`/admin/leilao/update`, data)
        .then((response) => {
          this.isLoading = false;

          this.forceDisconnect();

          this.showSuccessMessageWithButton("Sucesso", "Dados editados");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);

          this.isLoading = true;
        });
    },

    forceDisconnect() {
      let data = {
        leilao_id: this.leilao.id,
      };

      axios.post(process.env.MIX_VUE_APP_AUDITORIO + `/emit_disconnect`, data).then((response) => {});
    },

    changeCidade() {
      this.cadastrar_comitente = false;
      this.cadastrar_processo = false;
      this.buscarComitentes();
      this.buscarprocessos();

      //ZERANDO DADOS QUE VARIAM DE ACORDO COM CIDADE/ESTADO
      this.formData.comitente_id = null;
      this.formData.processo_id = null;
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.formData.estado_id,
      };

      this.formData.cidade_id = null;
      this.cadastrar_comitente = false;
      this.cadastrar_processo = false;

      //ZERANDO DADOS QUE VARIAM DE ACORDO COM CIDADE/ESTADO
      this.formData.comitente_id = null;
      this.formData.processo_id = null;

      this.my_comitentes = [];
      this.my_processos = [];

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.my_cidades = response.data.cidades;

          this.formData.cidade_id = null;

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>
